import { render, staticRenderFns } from "./ParentMain.vue?vue&type=template&id=a56155e0"
import script from "./ParentMain.vue?vue&type=script&lang=js"
export * from "./ParentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports